// extracted by mini-css-extract-plugin
export default {"wrapper":"ProfileLayout_wrapper__DoyW-","outlet":"ProfileLayout_outlet__IbauQ","loader":"ProfileLayout_loader__KfGdm"};